import 'core-js/fn/string/starts-with';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { Provider } from 'react-redux';
import './index.css';
import configureStore from './store';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import * as moment from 'moment';
import 'moment/locale/de'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#e2001a',
    },
    secondary: {
      main: '#d6d6d6',
    },
  },
  typography: {
    useNextVariants: true,
  }
});

moment.locale('de')

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Provider store={configureStore()}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <App />
      </MuiPickersUtilsProvider>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx